const indexItems = [
  {
    id: 1,
    title: '吃瓜黑料网站精选',
    desc: '收录全网最优质的吃瓜来源，明星八卦、网红爆料一网打尽',
    count: '38个来源',
    color: 'bg-primary-100 text-primary-700',
  },
  {
    id: 2,
    title: '51黑料网站专区',
    desc: '51黑料网站定向追踪，实时同步热门内容与最新动态',
    count: '每日更新',
    color: 'bg-accent-100 text-accent-700',
  },
  {
    id: 3,
    title: '91黑料网站专区',
    desc: '91黑料网站深度报道与独家爆料精选合集',
    count: '每日更新',
    color: 'bg-accent-100 text-accent-700',
  },
  {
    id: 4,
    title: '网红翻车全集',
    desc: '网红带货翻车、人设崩塌事件收集与时间线整理',
    count: '156条记录',
    color: 'bg-secondary-100 text-secondary-700',
  },
  {
    id: 5,
    title: '明星恋情追踪',
    desc: '明星恋情曝光、分手、出轨等情感类黑料持续跟进',
    count: '89条记录',
    color: 'bg-secondary-100 text-secondary-700',
  },
  {
    id: 6,
    title: '影视综艺黑幕',
    desc: '选秀节目、综艺录制、影视剧组幕后不为人知的故事',
    count: '72条记录',
    color: 'bg-background-200 text-foreground-700',
  },
  {
    id: 7,
    title: '最新黑料网站大全',
    desc: '持续收录新上线的黑料网站及小众吃瓜平台推荐',
    count: '持续扩充',
    color: 'bg-background-200 text-foreground-700',
  },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-950">
            黑料索引
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            按主题快速检索，精准定位你感兴趣的爆料内容
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
          {indexItems.slice(0, 4).map((item) => (
            <a
              key={item.id}
              href="#"
              className="bg-background-100 rounded-xl p-5 border border-background-200/70 hover:border-primary-200/50 transition-all duration-300 cursor-pointer group"
            >
              <div className="flex items-center justify-between mb-3">
                <span className={`text-xs font-semibold px-3 py-1 rounded-full whitespace-nowrap ${item.color}`}>
                  {item.count}
                </span>
                <i className="ri-arrow-right-up-line text-foreground-300 group-hover:text-primary-500 transition-colors"></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors">
                {item.title}
              </h3>
              <p className="mt-2 text-sm text-foreground-500 leading-relaxed">
                {item.desc}
              </p>
            </a>
          ))}
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-4">
          {indexItems.slice(4).map((item) => (
            <a
              key={item.id}
              href="#"
              className="bg-background-100 rounded-xl p-5 border border-background-200/70 hover:border-primary-200/50 transition-all duration-300 cursor-pointer group"
            >
              <div className="flex items-center justify-between mb-3">
                <span className={`text-xs font-semibold px-3 py-1 rounded-full whitespace-nowrap ${item.color}`}>
                  {item.count}
                </span>
                <i className="ri-arrow-right-up-line text-foreground-300 group-hover:text-primary-500 transition-colors"></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors">
                {item.title}
              </h3>
              <p className="mt-2 text-sm text-foreground-500 leading-relaxed">
                {item.desc}
              </p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}